module.exports = __webpack_public_path__ + "static/media/earnedInADay_3000_5000.977b1eda.png";